import { postMediaTypes, } from 'application/pageDataObject';
import { body, classList, } from 'utils/dom';
import { warn, } from 'application/console';

function getTemplateClassName(mediaType){
  return `media-type--${ mediaType }`;
}

export default function initPageTemplateClassifier(){
  const classNames = postMediaTypes.map(getTemplateClassName);
  if (!classNames.length) {
    warn('This page has no templates', { postMediaTypes, classNames, });
    return;
  }
  classList(body).add(...classNames);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/pageTemplateClassifier.js